import React, { useState } from 'react';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import ModalLogin from '../../Containers/Modal_Login';
import ModalRegister from '../../Containers/Modal_Register';
import ModalSuccess from '../../Containers/ModalSuccess';
import ModalResult from '../../Containers/ModalResult';
import { Document, Page, pdfjs } from 'react-pdf';
import './style.scss';

const AckPage = () => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  return (
    <div className='faq-page'>
      <Header />
      <main>
        <div className='faq'>
          <div className='container'>
            <div className='header'>
              <h2 className='title'>
                <span className='black'>
                  Quyết định số 377/QĐ-BTTTT ngày 26/3/2021 của
                </span>{' '}
                <span className='red'>
                  Bộ trưởng Bộ Thông tin và Truyền thông
                </span>
              </h2>
              {/* <p className='des'>Hướng dẫn bạn sử dụng chức năng trên SMEdx</p> */}
            </div>
            <div className='pdf-container'>
              <Document
                file='/smedx/QUYET_DINH_377_BTTTT.pdf'
                onLoadSuccess={onDocumentLoadSuccess}
                className='pdf-viewer'
              >
                <Page pageNumber={pageNumber} />
              </Document>
              <div className='pdf-pages'>
                <button
                  className='pdf-control'
                  onClick={() =>
                    pageNumber > 1 && setPageNumber(pageNumber - 1)
                  }
                >
                  {'<'}
                </button>
                <p>
                  Trang {pageNumber} / {numPages}
                </p>
                <button
                  className='pdf-control'
                  onClick={() =>
                    pageNumber < numPages && setPageNumber(pageNumber + 1)
                  }
                >
                  {'>'}
                </button>
              </div>
            </div>
          </div>
        </div>
        <ModalLogin />
        <ModalRegister />
        <ModalSuccess />
      </main>
      <Footer />
    </div>
  );
};
export default AckPage;
